import { Account } from '@robocorp/id-sdk/lib/sdk/types';
import { idServiceAccountsApi } from '~/utils/api';

export const getPartnerAccounts = (userId: string) => {
  return idServiceAccountsApi.get<Account[]>(`/accounts/users/${userId}`);
};

export const getPartnerAccount = (accountId: string) => {
  return idServiceAccountsApi.get<Account>(`/accounts/${accountId}`);
};
